import api from './api';

export async function getOrdersAPI() {
  return api.get(`/api/backoffice/Orders`).then((response) => response.data);
}

export async function getOrderByIdAPI(orderId: string) {
  return api.get(`/api/backoffice/Orders/${orderId}`).then((response) => response.data);
}

export async function getOrderRelatedTopupsAPI(orderId: string) {
  return api.get(`/api/backoffice/Orders/${orderId}/related-topups`).then((response) => response.data);
}

export type CompletePaymentPayload = {
  amountPaid: number;
  amountDiscount: number;
  status: 'PAID' | 'FAILED' | 'EXPIRED' | 'REFUNDED';
};

export async function completeOrderPaymentAPI(orderId: string, paymentId: string, payload: CompletePaymentPayload) {
  return api
    .put(`/api/backoffice/Orders/${orderId}/payments/${paymentId}/complete`, payload)
    .then((response) => response.data);
}
